import { Button } from '@fluentui/react-components';
import { DataPie20Regular } from '@fluentui/react-icons';
import { Link } from 'react-router-dom';

type TProps = {
  href: string;
};

const OpenDashboardButton = ({ href }: TProps) => (
  <Link to={href} className="no-underline">
    <Button appearance="secondary" icon={<DataPie20Regular />}>
      Open dashboard
    </Button>
  </Link>
);

export default OpenDashboardButton;
